module.exports = __webpack_public_path__ + "static/media/homepage_backgroud1.5e6bf580.png";